import type { DeepPartial } from '@luna/utils-ts';

import type { Orders } from '../../types/Orders';

export const ordersHRFeatureConfig: DeepPartial<Orders> = {
    showExtendedDetailsView: true,
    stickyHeaderMobile: true,
};
